import { resolveShopifyAdminProductId } from '@utils/shopifyIds';

import { CollectionSetProduct } from '../../../types/Purchasing';
import { CHECKOUT_WORKS_PARAM } from '../constants';

type Query = Partial<Record<string, string | string[]>>;

type SetMember = Pick<
  CollectionSetProduct,
  'initial' | 'selected' | 'shopifyId'
>;

// The set members picked on a product page, for the checkout's works. Empty
// when only the page's own work is picked, which the checkout selects anyway.
export const selectedSetWorkIds = (
  collectionSet: SetMember[] | null | undefined,
): string[] => {
  const picked = (collectionSet ?? []).filter(({ selected }) => selected);

  if (picked.length === 1 && picked[0].initial) return [];

  return picked
    .map(({ shopifyId }) => resolveShopifyAdminProductId(shopifyId))
    .filter((id): id is string => Boolean(id));
};

export const withWorksQuery = (link: string, productIds: string[]): string => {
  const [pathname, search = ''] = link.split('?');
  const params = new URLSearchParams(search);

  params.delete(CHECKOUT_WORKS_PARAM);
  if (productIds.length) {
    params.set(CHECKOUT_WORKS_PARAM, productIds.join(','));
  }

  const query = params.toString();

  return query ? `${pathname}?${query}` : pathname;
};

type ParseWorksArgs = {
  mainId: string;
  workIds: string[];
};

export const parseWorksQuery = (
  query: Query,
  { mainId, workIds }: ParseWorksArgs,
): string[] => {
  const value = query[CHECKOUT_WORKS_PARAM];
  const linkedIds = typeof value === 'string' ? value.split(',') : [];
  const selectedIds = [
    ...new Set(linkedIds.filter((id) => workIds.includes(id))),
  ];

  return selectedIds.length ? selectedIds : [mainId];
};
